import { CART_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDDeleteCartItemPostBody, IHDDeleteCartItemPostResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "../../useConfiguration";
import { setHDDeleteCartItem } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useDeleteCartItemAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IHDDeleteCartItemPostBody) => {
      dispatch(
        setLoading({
          key: "isInventoryProductGoodInventory",
          status: true,
        }),
      );
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${CART_MODULE?.HD_DELETE_CART_ITEM?.baseURL}`, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IHDDeleteCartItemPostResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setHDDeleteCartItem({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              dispatch(setHDDeleteCartItem({ data: null }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
